module.exports = __webpack_public_path__ + "static/media/web-6.b3821f31.jpg";